import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { TranslateService } from '@ngx-translate/core';

import { AuthService } from '@ridango/core';

import { ThemeFeature } from '@ridango/core/lib/enums/features.enum';
import { ApplicationFacade } from '@ridango/components';
import { DOCUMENT } from '@angular/common';
import Env from '@ridango/core/env';
import { ModalController } from '@ionic/angular';
import { FeedbackModalComponent } from './feedback-modal-component/feedback-modal.component';
import { StorageService } from '@ridango/core/lib/services/storage.service';
@Component({
    selector: 'gl-home-page',
    templateUrl: './home-page.component.html'
})
export class HomePageComponent implements OnInit {
    assetsPath$ = this.applicationFacade.assetsPath$;
    private readonly FEEDBACK_DECLINED_KEY = 'vl-feedback-modal-declined';
    themeFeature = ThemeFeature;

    openFeedbackModal() {
        this.storageService.getItem<boolean>(this.FEEDBACK_DECLINED_KEY).subscribe((hasDeclined) => {
            if (!hasDeclined) {
                this.modalCtrl
                    .create({
                        component: FeedbackModalComponent,
                        cssClass: 'feedback-modal'
                    })
                    .then((modal) => {
                        modal.present();
                    });
            }
        });
    }

    constructor(
        private applicationFacade: ApplicationFacade,
        public ridangoAuth: AuthService,
        private router: Router,
        private translate: TranslateService,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document,
        @Inject('ENV') public env: Env,
        private modalCtrl: ModalController,
        private storageService: StorageService
    ) {}

    ngOnInit() {
        if (Capacitor.isNativePlatform()) {
            this.router.navigate([this.translate.currentLang, 'explore']);
        }

        if (this.env.THEME_NAME === ThemeFeature.VL && this.env.SHOW_FEEDBACK_MODAL) {
            this.openFeedbackModal();
        }
    }
}
